import SV from 'server-vars';
import authModalLoader from '../../../utils/AuthModalLoader';

export const tradeWindfallReferralAction = () => dispatch => {
    const isUserTypeTrade = SV.get('settings.isUserTypeTrade') || false;
    // if the user is not a trade user
    if (!isUserTypeTrade) {
        const path = location.pathname || '';
        const isOnTradeApplicationPage = path.split('/trade/apply').length > 1;
        // if the user is not on the trade application page, launch the trade application
        if (!isOnTradeApplicationPage) {
            authModalLoader.showPostAuth({
                step: 'trade_basic_info',
                postAuthFlow: 'SUSPECTED_TRADE_APPLICATION',
            });
        }
    }

    return dispatch({ type: 'noop' });
};
